import { debounce } from 'lodash-es';
import { getElementParents } from '../helpers/general';

const autoCompleteTargets = document.querySelectorAll('[data-autocomplete]');
autoCompleteTargets.forEach((item) => {
  const autoCompleteField = item;

  if (autoCompleteField) {
    const autoCompleteData = autoCompleteField.dataset;
    const autoCompleteURL = autoCompleteData.autocomplete;
    const autoCompleteOffsetLeft = autoCompleteData.autocompleteOffsetLeft ? parseInt(autoCompleteData.autocompleteOffsetLeft, 10) : -10;
    const autoCompleteOffsetWidth = autoCompleteData.autocompleteOffsetWidth ? parseInt(autoCompleteData.autocompleteOffsetWidth, 10) : 0;
    const autoCompleteDisplayKey = autoCompleteData.autocompleteDisplayKey ? autoCompleteData.autocompleteDisplayKey : null;

    // Immediately submit form on selected result, this is KNGU specific
    autoCompleteField.addEventListener('autocomplete-result', () => {
      getElementParents(autoCompleteField, 'form')[0].submit();
    });

    // Turn of browser implementation of autocomplete
    autoCompleteField.setAttribute('autocomplete', 'off');

    const removeAutoComplete = () => {
      if (document.querySelector('.autocomplete-suggestions')) {
        document.querySelector('.autocomplete-suggestions').remove();
      }
    };

    const showAutoComplete = (results) => {
      removeAutoComplete();

      const documentBody = document.getElementsByTagName('body')[0];

      const ul = document.createElement('ul');
      ul.className = 'autocomplete-suggestions';

      function setSizeAndPosition() {
        const rect = autoCompleteField.getBoundingClientRect();
        const scrollTop = window.scrollY && window.scrollY >= 0 ? window.scrollY : document.documentElement.scrollTop;

        ul.style.top = `${(rect.top + rect.height) + scrollTop}px`;

        ul.style.left = `${rect.left + autoCompleteOffsetLeft}px`;
        ul.style.width = `${rect.width + autoCompleteOffsetWidth}px`;

        ul.style.position = 'absolute';
      }

      setSizeAndPosition();

      const suggestions = results;

      // Loop over max 10 results in the results array
      // eslint-disable-next-line no-plusplus
      for (let i = 0, l = 10; i < l; i++) {
        if (!suggestions[i]) {
          break;
        }

        const result = suggestions[i];
        let display = result;

        if (autoCompleteDisplayKey) {
          display = result[autoCompleteDisplayKey];
        }

        const li = document.createElement('li');
        li.innerText = display;

        const clickListener = (displayValue, responseObject) => () => {
          autoCompleteField.value = displayValue;
          autoCompleteField.focus();
          autoCompleteField.removeAttribute('data-first-suggestion-value');
          const autoCompleteEvent = new CustomEvent('autocomplete-result', {
            detail: {
              displayValue,
              responseObject,
            },
            cancelable: true,
            bubbles: false,
          });
          autoCompleteField.dispatchEvent(autoCompleteEvent);
        };

        // Click handler to fill field and return focus
        li.addEventListener('mousedown', clickListener(display, result));

        ul.appendChild(li);
      }

      if (suggestions.length) {
        const firstSuggestionDisplayValue = suggestions[0].DisplayValue;
        autoCompleteField.setAttribute('data-first-suggestion-value', firstSuggestionDisplayValue);
      }

      if (suggestions.length) {
        documentBody.appendChild(ul);
      }

      window.addEventListener('resize', setSizeAndPosition);
    };

    // Debounce the ajax request on input to prevent flooding the autocomplete endpoint
    // eslint-disable-next-line consistent-return
    const inputHandler = debounce((e) => {
      const { value } = e.target;

      if (!value) {
        removeAutoComplete();
        return false;
      }
      fetch(`${autoCompleteURL}?q=${encodeURIComponent(value)}`)
        .then((res) => res.json())
        .then(showAutoComplete);
    }, 200);

    const setAutocompleteSuggestionValue = () => {
      const { value } = autoCompleteField;
      const { firstSuggestionValue } = autoCompleteField.dataset;

      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(value) && firstSuggestionValue) {
        autoCompleteField.innerHTML = firstSuggestionValue;
      }
    };

    // Debounce blur to allow for the click handler to properly function
    autoCompleteField.addEventListener('blur', debounce(removeAutoComplete, 100));
    autoCompleteField.addEventListener('blur', setAutocompleteSuggestionValue);
    autoCompleteField.addEventListener('keypress', (e) => {
      if (e.which === 13) {
        setAutocompleteSuggestionValue();
      }
    });
    autoCompleteField.addEventListener('input', inputHandler);

    autoCompleteField.addEventListener('keydown', (e) => {
      const lis = document.querySelectorAll('.autocomplete-suggestions > li');
      const selected = document.querySelector('.autocomplete-suggestions > li.selected');

      // eslint-disable-next-line default-case
      switch (e.keyCode) {
        case 40: // down arrow
          if (!selected) {
            lis[0].classList.add('selected');
          } else {
            // Loop through and select next if there is one
            // eslint-disable-next-line no-plusplus
            for (let i = 0, l = lis.length; i < l; i++) {
              const el = lis[i];

              if (el.classList.contains('selected') && lis[i + 1]) {
                el.classList.remove('selected');
                lis[i + 1].classList.add('selected');
                break;
              }
            }
          }
          break;

        case 38: // up arrow
          if (selected) {
            // Loop through and select previous if there is one
            // eslint-disable-next-line no-plusplus
            for (let i = 0, l = lis.length; i < l; i++) {
              const el = lis[i];

              if (el.classList.contains('selected')) {
                el.classList.remove('selected');

                if (lis[i - 1]) {
                  lis[i - 1].classList.add('selected');
                }

                break;
              }
            }
          }
          break;

        case 13: // enter
          // If there is a selected option, mirror it to the field otherwise just do the default event action
          if (selected) {
            selected.dispatchEvent(new Event('mousedown'));
            selected.classList.remove('selected');
            e.preventDefault();
            removeAutoComplete();
          }
          break;

        case 27:
          removeAutoComplete();
          break;
      }
    });
  }
});
